import { getLocale } from "../runtime";

const sv_allbrands = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Alla varumärken`
};

const allbrands = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_allbrands(inputs)
	return "allBrands";
};

export { allbrands as "allBrands" };